// Guardian AI Payment Service Protocol Definitions
// Payments, subscriptions, scan credits, and Stripe integration
//
// Version: v1
// Source: Merged from backend payment.proto + frontend payment.proto

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/payment/payment.proto (package guardianai.v1.payment, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/payment/payment.proto.
 */
export const file_guardianai_v1_payment_payment: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.payment.CreatePaymentIntentRequest
 */
export type CreatePaymentIntentRequest = Message<"guardianai.v1.payment.CreatePaymentIntentRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: optional string referral_code = 6;
   */
  referralCode?: string;
};

/**
 * @generated from message guardianai.v1.payment.CreatePaymentIntentRequest
 */
export type CreatePaymentIntentRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 3;
   */
  currency?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: optional string referral_code = 6;
   */
  referralCode?: string;
};

/**
 * Describes the message guardianai.v1.payment.CreatePaymentIntentRequest.
 * Use `create(CreatePaymentIntentRequestSchema)` to create a new message.
 */
export const CreatePaymentIntentRequestSchema: GenMessage<CreatePaymentIntentRequest, {jsonType: CreatePaymentIntentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 0);

/**
 * @generated from message guardianai.v1.payment.PaymentIntentResponse
 */
export type PaymentIntentResponse = Message<"guardianai.v1.payment.PaymentIntentResponse"> & {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;
};

/**
 * @generated from message guardianai.v1.payment.PaymentIntentResponse
 */
export type PaymentIntentResponseJson = {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId?: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents?: string;
};

/**
 * Describes the message guardianai.v1.payment.PaymentIntentResponse.
 * Use `create(PaymentIntentResponseSchema)` to create a new message.
 */
export const PaymentIntentResponseSchema: GenMessage<PaymentIntentResponse, {jsonType: PaymentIntentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 1);

/**
 * @generated from message guardianai.v1.payment.ConfirmPaymentRequest
 */
export type ConfirmPaymentRequest = Message<"guardianai.v1.payment.ConfirmPaymentRequest"> & {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId: string;

  /**
   * @generated from field: string payment_method_id = 2;
   */
  paymentMethodId: string;
};

/**
 * @generated from message guardianai.v1.payment.ConfirmPaymentRequest
 */
export type ConfirmPaymentRequestJson = {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId?: string;

  /**
   * @generated from field: string payment_method_id = 2;
   */
  paymentMethodId?: string;
};

/**
 * Describes the message guardianai.v1.payment.ConfirmPaymentRequest.
 * Use `create(ConfirmPaymentRequestSchema)` to create a new message.
 */
export const ConfirmPaymentRequestSchema: GenMessage<ConfirmPaymentRequest, {jsonType: ConfirmPaymentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 2);

/**
 * @generated from message guardianai.v1.payment.PaymentResponse
 */
export type PaymentResponse = Message<"guardianai.v1.payment.PaymentResponse"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: int64 amount_cents = 5;
   */
  amountCents: bigint;
};

/**
 * @generated from message guardianai.v1.payment.PaymentResponse
 */
export type PaymentResponseJson = {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: string message = 4;
   */
  message?: string;

  /**
   * @generated from field: int64 amount_cents = 5;
   */
  amountCents?: string;
};

/**
 * Describes the message guardianai.v1.payment.PaymentResponse.
 * Use `create(PaymentResponseSchema)` to create a new message.
 */
export const PaymentResponseSchema: GenMessage<PaymentResponse, {jsonType: PaymentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 3);

/**
 * @generated from message guardianai.v1.payment.GetPaymentHistoryRequest
 */
export type GetPaymentHistoryRequest = Message<"guardianai.v1.payment.GetPaymentHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.payment.GetPaymentHistoryRequest
 */
export type GetPaymentHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.payment.GetPaymentHistoryRequest.
 * Use `create(GetPaymentHistoryRequestSchema)` to create a new message.
 */
export const GetPaymentHistoryRequestSchema: GenMessage<GetPaymentHistoryRequest, {jsonType: GetPaymentHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 4);

/**
 * @generated from message guardianai.v1.payment.PaymentHistoryResponse
 */
export type PaymentHistoryResponse = Message<"guardianai.v1.payment.PaymentHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.PaymentRecord payments = 1;
   */
  payments: PaymentRecord[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.payment.PaymentHistoryResponse
 */
export type PaymentHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.PaymentRecord payments = 1;
   */
  payments?: PaymentRecordJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.payment.PaymentHistoryResponse.
 * Use `create(PaymentHistoryResponseSchema)` to create a new message.
 */
export const PaymentHistoryResponseSchema: GenMessage<PaymentHistoryResponse, {jsonType: PaymentHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 5);

/**
 * @generated from message guardianai.v1.payment.PaymentRecord
 */
export type PaymentRecord = Message<"guardianai.v1.payment.PaymentRecord"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.PaymentRecord
 */
export type PaymentRecordJson = {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 3;
   */
  currency?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.PaymentRecord.
 * Use `create(PaymentRecordSchema)` to create a new message.
 */
export const PaymentRecordSchema: GenMessage<PaymentRecord, {jsonType: PaymentRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 6);

/**
 * @generated from message guardianai.v1.payment.RefundRequest
 */
export type RefundRequest = Message<"guardianai.v1.payment.RefundRequest"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.payment.RefundRequest
 */
export type RefundRequestJson = {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.payment.RefundRequest.
 * Use `create(RefundRequestSchema)` to create a new message.
 */
export const RefundRequestSchema: GenMessage<RefundRequest, {jsonType: RefundRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 7);

/**
 * @generated from message guardianai.v1.payment.RefundResponse
 */
export type RefundResponse = Message<"guardianai.v1.payment.RefundResponse"> & {
  /**
   * @generated from field: string refund_id = 1;
   */
  refundId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string status = 4;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.payment.RefundResponse
 */
export type RefundResponseJson = {
  /**
   * @generated from field: string refund_id = 1;
   */
  refundId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.payment.RefundResponse.
 * Use `create(RefundResponseSchema)` to create a new message.
 */
export const RefundResponseSchema: GenMessage<RefundResponse, {jsonType: RefundResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 8);

/**
 * @generated from message guardianai.v1.payment.UpdatePaymentMethodRequest
 */
export type UpdatePaymentMethodRequest = Message<"guardianai.v1.payment.UpdatePaymentMethodRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string payment_method_id = 2;
   */
  paymentMethodId: string;

  /**
   * @generated from field: bool set_default = 3;
   */
  setDefault: boolean;
};

/**
 * @generated from message guardianai.v1.payment.UpdatePaymentMethodRequest
 */
export type UpdatePaymentMethodRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string payment_method_id = 2;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: bool set_default = 3;
   */
  setDefault?: boolean;
};

/**
 * Describes the message guardianai.v1.payment.UpdatePaymentMethodRequest.
 * Use `create(UpdatePaymentMethodRequestSchema)` to create a new message.
 */
export const UpdatePaymentMethodRequestSchema: GenMessage<UpdatePaymentMethodRequest, {jsonType: UpdatePaymentMethodRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 9);

/**
 * @generated from message guardianai.v1.payment.PaymentMethodResponse
 */
export type PaymentMethodResponse = Message<"guardianai.v1.payment.PaymentMethodResponse"> & {
  /**
   * @generated from field: string payment_method_id = 1;
   */
  paymentMethodId: string;

  /**
   * @generated from field: string card_brand = 2;
   */
  cardBrand: string;

  /**
   * @generated from field: string last_four = 3;
   */
  lastFour: string;

  /**
   * @generated from field: int32 exp_month = 4;
   */
  expMonth: number;

  /**
   * @generated from field: int32 exp_year = 5;
   */
  expYear: number;

  /**
   * @generated from field: bool is_default = 6;
   */
  isDefault: boolean;
};

/**
 * @generated from message guardianai.v1.payment.PaymentMethodResponse
 */
export type PaymentMethodResponseJson = {
  /**
   * @generated from field: string payment_method_id = 1;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: string card_brand = 2;
   */
  cardBrand?: string;

  /**
   * @generated from field: string last_four = 3;
   */
  lastFour?: string;

  /**
   * @generated from field: int32 exp_month = 4;
   */
  expMonth?: number;

  /**
   * @generated from field: int32 exp_year = 5;
   */
  expYear?: number;

  /**
   * @generated from field: bool is_default = 6;
   */
  isDefault?: boolean;
};

/**
 * Describes the message guardianai.v1.payment.PaymentMethodResponse.
 * Use `create(PaymentMethodResponseSchema)` to create a new message.
 */
export const PaymentMethodResponseSchema: GenMessage<PaymentMethodResponse, {jsonType: PaymentMethodResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 10);

/**
 * @generated from message guardianai.v1.payment.GetInvoicesRequest
 */
export type GetInvoicesRequest = Message<"guardianai.v1.payment.GetInvoicesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.payment.GetInvoicesRequest
 */
export type GetInvoicesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.payment.GetInvoicesRequest.
 * Use `create(GetInvoicesRequestSchema)` to create a new message.
 */
export const GetInvoicesRequestSchema: GenMessage<GetInvoicesRequest, {jsonType: GetInvoicesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 11);

/**
 * @generated from message guardianai.v1.payment.InvoicesResponse
 */
export type InvoicesResponse = Message<"guardianai.v1.payment.InvoicesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.Invoice invoices = 1;
   */
  invoices: Invoice[];
};

/**
 * @generated from message guardianai.v1.payment.InvoicesResponse
 */
export type InvoicesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.Invoice invoices = 1;
   */
  invoices?: InvoiceJson[];
};

/**
 * Describes the message guardianai.v1.payment.InvoicesResponse.
 * Use `create(InvoicesResponseSchema)` to create a new message.
 */
export const InvoicesResponseSchema: GenMessage<InvoicesResponse, {jsonType: InvoicesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 12);

/**
 * @generated from message guardianai.v1.payment.Invoice
 */
export type Invoice = Message<"guardianai.v1.payment.Invoice"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string pdf_url = 4;
   */
  pdfUrl: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.Invoice
 */
export type InvoiceJson = {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: string pdf_url = 4;
   */
  pdfUrl?: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema: GenMessage<Invoice, {jsonType: InvoiceJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 13);

/**
 * @generated from message guardianai.v1.payment.WebhookRequest
 */
export type WebhookRequest = Message<"guardianai.v1.payment.WebhookRequest"> & {
  /**
   * @generated from field: string payload = 1;
   */
  payload: string;

  /**
   * @generated from field: string signature = 2;
   */
  signature: string;
};

/**
 * @generated from message guardianai.v1.payment.WebhookRequest
 */
export type WebhookRequestJson = {
  /**
   * @generated from field: string payload = 1;
   */
  payload?: string;

  /**
   * @generated from field: string signature = 2;
   */
  signature?: string;
};

/**
 * Describes the message guardianai.v1.payment.WebhookRequest.
 * Use `create(WebhookRequestSchema)` to create a new message.
 */
export const WebhookRequestSchema: GenMessage<WebhookRequest, {jsonType: WebhookRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 14);

/**
 * @generated from message guardianai.v1.payment.WebhookResponse
 */
export type WebhookResponse = Message<"guardianai.v1.payment.WebhookResponse"> & {
  /**
   * @generated from field: bool processed = 1;
   */
  processed: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.WebhookResponse
 */
export type WebhookResponseJson = {
  /**
   * @generated from field: bool processed = 1;
   */
  processed?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.WebhookResponse.
 * Use `create(WebhookResponseSchema)` to create a new message.
 */
export const WebhookResponseSchema: GenMessage<WebhookResponse, {jsonType: WebhookResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 15);

/**
 * @generated from message guardianai.v1.payment.InitiatePaymentRequest
 */
export type InitiatePaymentRequest = Message<"guardianai.v1.payment.InitiatePaymentRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * @generated from field: double amount = 3;
   */
  amount: number;

  /**
   * @generated from field: string payment_method = 4;
   */
  paymentMethod: string;

  /**
   * @generated from field: optional string referral_code = 5;
   */
  referralCode?: string;
};

/**
 * @generated from message guardianai.v1.payment.InitiatePaymentRequest
 */
export type InitiatePaymentRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId?: string;

  /**
   * @generated from field: double amount = 3;
   */
  amount?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string payment_method = 4;
   */
  paymentMethod?: string;

  /**
   * @generated from field: optional string referral_code = 5;
   */
  referralCode?: string;
};

/**
 * Describes the message guardianai.v1.payment.InitiatePaymentRequest.
 * Use `create(InitiatePaymentRequestSchema)` to create a new message.
 */
export const InitiatePaymentRequestSchema: GenMessage<InitiatePaymentRequest, {jsonType: InitiatePaymentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 16);

/**
 * @generated from message guardianai.v1.payment.GetPaymentStatusRequest
 */
export type GetPaymentStatusRequest = Message<"guardianai.v1.payment.GetPaymentStatusRequest"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetPaymentStatusRequest
 */
export type GetPaymentStatusRequestJson = {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetPaymentStatusRequest.
 * Use `create(GetPaymentStatusRequestSchema)` to create a new message.
 */
export const GetPaymentStatusRequestSchema: GenMessage<GetPaymentStatusRequest, {jsonType: GetPaymentStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 17);

/**
 * @generated from message guardianai.v1.payment.PaymentStatusResponse
 */
export type PaymentStatusResponse = Message<"guardianai.v1.payment.PaymentStatusResponse"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.PaymentStatusResponse
 */
export type PaymentStatusResponseJson = {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.PaymentStatusResponse.
 * Use `create(PaymentStatusResponseSchema)` to create a new message.
 */
export const PaymentStatusResponseSchema: GenMessage<PaymentStatusResponse, {jsonType: PaymentStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 18);

/**
 * @generated from message guardianai.v1.payment.CreateSubscriptionRequest
 */
export type CreateSubscriptionRequest = Message<"guardianai.v1.payment.CreateSubscriptionRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * @generated from field: string payment_method_id = 3;
   */
  paymentMethodId: string;

  /**
   * @generated from field: optional string referral_code = 4;
   */
  referralCode?: string;
};

/**
 * @generated from message guardianai.v1.payment.CreateSubscriptionRequest
 */
export type CreateSubscriptionRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId?: string;

  /**
   * @generated from field: string payment_method_id = 3;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string referral_code = 4;
   */
  referralCode?: string;
};

/**
 * Describes the message guardianai.v1.payment.CreateSubscriptionRequest.
 * Use `create(CreateSubscriptionRequestSchema)` to create a new message.
 */
export const CreateSubscriptionRequestSchema: GenMessage<CreateSubscriptionRequest, {jsonType: CreateSubscriptionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 19);

/**
 * @generated from message guardianai.v1.payment.SubscriptionResponse
 */
export type SubscriptionResponse = Message<"guardianai.v1.payment.SubscriptionResponse"> & {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 current_period_start = 4;
   */
  currentPeriodStart: bigint;

  /**
   * @generated from field: int64 current_period_end = 5;
   */
  currentPeriodEnd: bigint;

  /**
   * @generated from field: bool cancel_at_period_end = 6;
   */
  cancelAtPeriodEnd: boolean;

  /**
   * Alias for current_period_end for frontend compatibility
   *
   * @generated from field: int64 valid_until = 7;
   */
  validUntil: bigint;

  /**
   * @generated from field: string product_id = 8;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.payment.SubscriptionResponse
 */
export type SubscriptionResponseJson = {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId?: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int64 current_period_start = 4;
   */
  currentPeriodStart?: string;

  /**
   * @generated from field: int64 current_period_end = 5;
   */
  currentPeriodEnd?: string;

  /**
   * @generated from field: bool cancel_at_period_end = 6;
   */
  cancelAtPeriodEnd?: boolean;

  /**
   * Alias for current_period_end for frontend compatibility
   *
   * @generated from field: int64 valid_until = 7;
   */
  validUntil?: string;

  /**
   * @generated from field: string product_id = 8;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.payment.SubscriptionResponse.
 * Use `create(SubscriptionResponseSchema)` to create a new message.
 */
export const SubscriptionResponseSchema: GenMessage<SubscriptionResponse, {jsonType: SubscriptionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 20);

/**
 * @generated from message guardianai.v1.payment.GetSubscriptionStatusRequest
 */
export type GetSubscriptionStatusRequest = Message<"guardianai.v1.payment.GetSubscriptionStatusRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string product_id = 2;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetSubscriptionStatusRequest
 */
export type GetSubscriptionStatusRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string product_id = 2;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetSubscriptionStatusRequest.
 * Use `create(GetSubscriptionStatusRequestSchema)` to create a new message.
 */
export const GetSubscriptionStatusRequestSchema: GenMessage<GetSubscriptionStatusRequest, {jsonType: GetSubscriptionStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 21);

/**
 * @generated from message guardianai.v1.payment.ListActiveProductSubscriptionsRequest
 */
export type ListActiveProductSubscriptionsRequest = Message<"guardianai.v1.payment.ListActiveProductSubscriptionsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.ListActiveProductSubscriptionsRequest
 */
export type ListActiveProductSubscriptionsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.ListActiveProductSubscriptionsRequest.
 * Use `create(ListActiveProductSubscriptionsRequestSchema)` to create a new message.
 */
export const ListActiveProductSubscriptionsRequestSchema: GenMessage<ListActiveProductSubscriptionsRequest, {jsonType: ListActiveProductSubscriptionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 22);

/**
 * @generated from message guardianai.v1.payment.ListActiveProductSubscriptionsResponse
 */
export type ListActiveProductSubscriptionsResponse = Message<"guardianai.v1.payment.ListActiveProductSubscriptionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.SubscriptionResponse subscriptions = 1;
   */
  subscriptions: SubscriptionResponse[];
};

/**
 * @generated from message guardianai.v1.payment.ListActiveProductSubscriptionsResponse
 */
export type ListActiveProductSubscriptionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.SubscriptionResponse subscriptions = 1;
   */
  subscriptions?: SubscriptionResponseJson[];
};

/**
 * Describes the message guardianai.v1.payment.ListActiveProductSubscriptionsResponse.
 * Use `create(ListActiveProductSubscriptionsResponseSchema)` to create a new message.
 */
export const ListActiveProductSubscriptionsResponseSchema: GenMessage<ListActiveProductSubscriptionsResponse, {jsonType: ListActiveProductSubscriptionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 23);

/**
 * @generated from message guardianai.v1.payment.CancelSubscriptionRequest
 */
export type CancelSubscriptionRequest = Message<"guardianai.v1.payment.CancelSubscriptionRequest"> & {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * @generated from field: bool at_period_end = 2;
   */
  atPeriodEnd: boolean;
};

/**
 * @generated from message guardianai.v1.payment.CancelSubscriptionRequest
 */
export type CancelSubscriptionRequestJson = {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId?: string;

  /**
   * @generated from field: bool at_period_end = 2;
   */
  atPeriodEnd?: boolean;
};

/**
 * Describes the message guardianai.v1.payment.CancelSubscriptionRequest.
 * Use `create(CancelSubscriptionRequestSchema)` to create a new message.
 */
export const CancelSubscriptionRequestSchema: GenMessage<CancelSubscriptionRequest, {jsonType: CancelSubscriptionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 24);

/**
 * @generated from message guardianai.v1.payment.CancelSubscriptionResponse
 */
export type CancelSubscriptionResponse = Message<"guardianai.v1.payment.CancelSubscriptionResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.CancelSubscriptionResponse
 */
export type CancelSubscriptionResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.CancelSubscriptionResponse.
 * Use `create(CancelSubscriptionResponseSchema)` to create a new message.
 */
export const CancelSubscriptionResponseSchema: GenMessage<CancelSubscriptionResponse, {jsonType: CancelSubscriptionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 25);

/**
 * @generated from message guardianai.v1.payment.SubscribeToPlanRequest
 */
export type SubscribeToPlanRequest = Message<"guardianai.v1.payment.SubscribeToPlanRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * @generated from field: optional string referral_code = 3;
   */
  referralCode?: string;

  /**
   * @generated from field: string product_id = 4;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.payment.SubscribeToPlanRequest
 */
export type SubscribeToPlanRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId?: string;

  /**
   * @generated from field: optional string referral_code = 3;
   */
  referralCode?: string;

  /**
   * @generated from field: string product_id = 4;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.payment.SubscribeToPlanRequest.
 * Use `create(SubscribeToPlanRequestSchema)` to create a new message.
 */
export const SubscribeToPlanRequestSchema: GenMessage<SubscribeToPlanRequest, {jsonType: SubscribeToPlanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 26);

/**
 * @generated from message guardianai.v1.payment.SubscribeResponse
 */
export type SubscribeResponse = Message<"guardianai.v1.payment.SubscribeResponse"> & {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string checkout_url = 3;
   */
  checkoutUrl: string;
};

/**
 * @generated from message guardianai.v1.payment.SubscribeResponse
 */
export type SubscribeResponseJson = {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string checkout_url = 3;
   */
  checkoutUrl?: string;
};

/**
 * Describes the message guardianai.v1.payment.SubscribeResponse.
 * Use `create(SubscribeResponseSchema)` to create a new message.
 */
export const SubscribeResponseSchema: GenMessage<SubscribeResponse, {jsonType: SubscribeResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 27);

/**
 * @generated from message guardianai.v1.payment.CreateScanCreditCheckoutSessionRequest
 */
export type CreateScanCreditCheckoutSessionRequest = Message<"guardianai.v1.payment.CreateScanCreditCheckoutSessionRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string package_id = 2;
   */
  packageId: string;

  /**
   * @generated from field: optional string referral_code = 3;
   */
  referralCode?: string;
};

/**
 * @generated from message guardianai.v1.payment.CreateScanCreditCheckoutSessionRequest
 */
export type CreateScanCreditCheckoutSessionRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string package_id = 2;
   */
  packageId?: string;

  /**
   * @generated from field: optional string referral_code = 3;
   */
  referralCode?: string;
};

/**
 * Describes the message guardianai.v1.payment.CreateScanCreditCheckoutSessionRequest.
 * Use `create(CreateScanCreditCheckoutSessionRequestSchema)` to create a new message.
 */
export const CreateScanCreditCheckoutSessionRequestSchema: GenMessage<CreateScanCreditCheckoutSessionRequest, {jsonType: CreateScanCreditCheckoutSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 28);

/**
 * @generated from message guardianai.v1.payment.ScanCreditCheckoutSessionResponse
 */
export type ScanCreditCheckoutSessionResponse = Message<"guardianai.v1.payment.ScanCreditCheckoutSessionResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string checkout_url = 2;
   */
  checkoutUrl: string;

  /**
   * @generated from field: string package_id = 3;
   */
  packageId: string;

  /**
   * @generated from field: int32 credits = 4;
   */
  credits: number;

  /**
   * @generated from field: int32 bonus_credits = 5;
   */
  bonusCredits: number;

  /**
   * @generated from field: int64 amount_cents = 6;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 7;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.payment.ScanCreditCheckoutSessionResponse
 */
export type ScanCreditCheckoutSessionResponseJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string checkout_url = 2;
   */
  checkoutUrl?: string;

  /**
   * @generated from field: string package_id = 3;
   */
  packageId?: string;

  /**
   * @generated from field: int32 credits = 4;
   */
  credits?: number;

  /**
   * @generated from field: int32 bonus_credits = 5;
   */
  bonusCredits?: number;

  /**
   * @generated from field: int64 amount_cents = 6;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 7;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.payment.ScanCreditCheckoutSessionResponse.
 * Use `create(ScanCreditCheckoutSessionResponseSchema)` to create a new message.
 */
export const ScanCreditCheckoutSessionResponseSchema: GenMessage<ScanCreditCheckoutSessionResponse, {jsonType: ScanCreditCheckoutSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 29);

/**
 * @generated from message guardianai.v1.payment.ScanCreditBalanceResponse
 */
export type ScanCreditBalanceResponse = Message<"guardianai.v1.payment.ScanCreditBalanceResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits: number;

  /**
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.payment.ScanCreditBalanceResponse
 */
export type ScanCreditBalanceResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits?: number;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.payment.ScanCreditBalanceResponse.
 * Use `create(ScanCreditBalanceResponseSchema)` to create a new message.
 */
export const ScanCreditBalanceResponseSchema: GenMessage<ScanCreditBalanceResponse, {jsonType: ScanCreditBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 30);

/**
 * @generated from message guardianai.v1.payment.GetScanCreditBalanceRequest
 */
export type GetScanCreditBalanceRequest = Message<"guardianai.v1.payment.GetScanCreditBalanceRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetScanCreditBalanceRequest
 */
export type GetScanCreditBalanceRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetScanCreditBalanceRequest.
 * Use `create(GetScanCreditBalanceRequestSchema)` to create a new message.
 */
export const GetScanCreditBalanceRequestSchema: GenMessage<GetScanCreditBalanceRequest, {jsonType: GetScanCreditBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 31);

/**
 * @generated from message guardianai.v1.payment.ListScanCreditUsageRequest
 */
export type ListScanCreditUsageRequest = Message<"guardianai.v1.payment.ListScanCreditUsageRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.ListScanCreditUsageRequest
 */
export type ListScanCreditUsageRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.ListScanCreditUsageRequest.
 * Use `create(ListScanCreditUsageRequestSchema)` to create a new message.
 */
export const ListScanCreditUsageRequestSchema: GenMessage<ListScanCreditUsageRequest, {jsonType: ListScanCreditUsageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 32);

/**
 * @generated from message guardianai.v1.payment.ScanCreditUsage
 */
export type ScanCreditUsage = Message<"guardianai.v1.payment.ScanCreditUsage"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string scan_id = 2;
   */
  scanId: string;

  /**
   * @generated from field: int32 credits_used = 3;
   */
  creditsUsed: number;

  /**
   * @generated from field: string timestamp = 4;
   */
  timestamp: string;
};

/**
 * @generated from message guardianai.v1.payment.ScanCreditUsage
 */
export type ScanCreditUsageJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string scan_id = 2;
   */
  scanId?: string;

  /**
   * @generated from field: int32 credits_used = 3;
   */
  creditsUsed?: number;

  /**
   * @generated from field: string timestamp = 4;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.payment.ScanCreditUsage.
 * Use `create(ScanCreditUsageSchema)` to create a new message.
 */
export const ScanCreditUsageSchema: GenMessage<ScanCreditUsage, {jsonType: ScanCreditUsageJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 33);

/**
 * @generated from message guardianai.v1.payment.ScanCreditUsageListResponse
 */
export type ScanCreditUsageListResponse = Message<"guardianai.v1.payment.ScanCreditUsageListResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.ScanCreditUsage usage = 1;
   */
  usage: ScanCreditUsage[];
};

/**
 * @generated from message guardianai.v1.payment.ScanCreditUsageListResponse
 */
export type ScanCreditUsageListResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.ScanCreditUsage usage = 1;
   */
  usage?: ScanCreditUsageJson[];
};

/**
 * Describes the message guardianai.v1.payment.ScanCreditUsageListResponse.
 * Use `create(ScanCreditUsageListResponseSchema)` to create a new message.
 */
export const ScanCreditUsageListResponseSchema: GenMessage<ScanCreditUsageListResponse, {jsonType: ScanCreditUsageListResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 34);

/**
 * @generated from message guardianai.v1.payment.DeductCreditsRequest
 */
export type DeductCreditsRequest = Message<"guardianai.v1.payment.DeductCreditsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string reference_id = 4;
   */
  referenceId: string;
};

/**
 * @generated from message guardianai.v1.payment.DeductCreditsRequest
 */
export type DeductCreditsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits?: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string reference_id = 4;
   */
  referenceId?: string;
};

/**
 * Describes the message guardianai.v1.payment.DeductCreditsRequest.
 * Use `create(DeductCreditsRequestSchema)` to create a new message.
 */
export const DeductCreditsRequestSchema: GenMessage<DeductCreditsRequest, {jsonType: DeductCreditsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 35);

/**
 * @generated from message guardianai.v1.payment.AddCreditsRequest
 */
export type AddCreditsRequest = Message<"guardianai.v1.payment.AddCreditsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string reference_id = 4;
   */
  referenceId: string;
};

/**
 * @generated from message guardianai.v1.payment.AddCreditsRequest
 */
export type AddCreditsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits?: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string reference_id = 4;
   */
  referenceId?: string;
};

/**
 * Describes the message guardianai.v1.payment.AddCreditsRequest.
 * Use `create(AddCreditsRequestSchema)` to create a new message.
 */
export const AddCreditsRequestSchema: GenMessage<AddCreditsRequest, {jsonType: AddCreditsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 36);

/**
 * @generated from message guardianai.v1.payment.GetCreditHistoryRequest
 */
export type GetCreditHistoryRequest = Message<"guardianai.v1.payment.GetCreditHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.payment.GetCreditHistoryRequest
 */
export type GetCreditHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.payment.GetCreditHistoryRequest.
 * Use `create(GetCreditHistoryRequestSchema)` to create a new message.
 */
export const GetCreditHistoryRequestSchema: GenMessage<GetCreditHistoryRequest, {jsonType: GetCreditHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 37);

/**
 * @generated from message guardianai.v1.payment.CreditHistoryResponse
 */
export type CreditHistoryResponse = Message<"guardianai.v1.payment.CreditHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.CreditTransaction transactions = 1;
   */
  transactions: CreditTransaction[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.payment.CreditHistoryResponse
 */
export type CreditHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.CreditTransaction transactions = 1;
   */
  transactions?: CreditTransactionJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.payment.CreditHistoryResponse.
 * Use `create(CreditHistoryResponseSchema)` to create a new message.
 */
export const CreditHistoryResponseSchema: GenMessage<CreditHistoryResponse, {jsonType: CreditHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 38);

/**
 * @generated from message guardianai.v1.payment.CreditTransaction
 */
export type CreditTransaction = Message<"guardianai.v1.payment.CreditTransaction"> & {
  /**
   * @generated from field: string transaction_id = 1;
   */
  transactionId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: int32 credits = 3;
   */
  credits: number;

  /**
   * PURCHASE, DEDUCT, REFUND, BONUS
   *
   * @generated from field: string type = 4;
   */
  type: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: string reference_id = 6;
   */
  referenceId: string;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.CreditTransaction
 */
export type CreditTransactionJson = {
  /**
   * @generated from field: string transaction_id = 1;
   */
  transactionId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: int32 credits = 3;
   */
  credits?: number;

  /**
   * PURCHASE, DEDUCT, REFUND, BONUS
   *
   * @generated from field: string type = 4;
   */
  type?: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason?: string;

  /**
   * @generated from field: string reference_id = 6;
   */
  referenceId?: string;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.CreditTransaction.
 * Use `create(CreditTransactionSchema)` to create a new message.
 */
export const CreditTransactionSchema: GenMessage<CreditTransaction, {jsonType: CreditTransactionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 39);

/**
 * @generated from message guardianai.v1.payment.GetScanCreditPackagesRequest
 */
export type GetScanCreditPackagesRequest = Message<"guardianai.v1.payment.GetScanCreditPackagesRequest"> & {
  /**
   * Optional: filter by currency (default: USD)
   *
   * @generated from field: string currency = 1;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.payment.GetScanCreditPackagesRequest
 */
export type GetScanCreditPackagesRequestJson = {
  /**
   * Optional: filter by currency (default: USD)
   *
   * @generated from field: string currency = 1;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetScanCreditPackagesRequest.
 * Use `create(GetScanCreditPackagesRequestSchema)` to create a new message.
 */
export const GetScanCreditPackagesRequestSchema: GenMessage<GetScanCreditPackagesRequest, {jsonType: GetScanCreditPackagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 40);

/**
 * @generated from message guardianai.v1.payment.ScanCreditPackagesResponse
 */
export type ScanCreditPackagesResponse = Message<"guardianai.v1.payment.ScanCreditPackagesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.ScanCreditPackage packages = 1;
   */
  packages: ScanCreditPackage[];
};

/**
 * @generated from message guardianai.v1.payment.ScanCreditPackagesResponse
 */
export type ScanCreditPackagesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.ScanCreditPackage packages = 1;
   */
  packages?: ScanCreditPackageJson[];
};

/**
 * Describes the message guardianai.v1.payment.ScanCreditPackagesResponse.
 * Use `create(ScanCreditPackagesResponseSchema)` to create a new message.
 */
export const ScanCreditPackagesResponseSchema: GenMessage<ScanCreditPackagesResponse, {jsonType: ScanCreditPackagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 41);

/**
 * @generated from message guardianai.v1.payment.ScanCreditPackage
 */
export type ScanCreditPackage = Message<"guardianai.v1.payment.ScanCreditPackage"> & {
  /**
   * @generated from field: string package_id = 1;
   */
  packageId: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits: number;

  /**
   * @generated from field: double price_amount = 3;
   */
  priceAmount: number;

  /**
   * @generated from field: string price_currency = 4;
   */
  priceCurrency: string;

  /**
   * @generated from field: int32 bonus_credits = 5;
   */
  bonusCredits: number;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool popular = 7;
   */
  popular: boolean;

  /**
   * @generated from field: bool best_value = 8;
   */
  bestValue: boolean;
};

/**
 * @generated from message guardianai.v1.payment.ScanCreditPackage
 */
export type ScanCreditPackageJson = {
  /**
   * @generated from field: string package_id = 1;
   */
  packageId?: string;

  /**
   * @generated from field: int32 credits = 2;
   */
  credits?: number;

  /**
   * @generated from field: double price_amount = 3;
   */
  priceAmount?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string price_currency = 4;
   */
  priceCurrency?: string;

  /**
   * @generated from field: int32 bonus_credits = 5;
   */
  bonusCredits?: number;

  /**
   * @generated from field: string description = 6;
   */
  description?: string;

  /**
   * @generated from field: bool popular = 7;
   */
  popular?: boolean;

  /**
   * @generated from field: bool best_value = 8;
   */
  bestValue?: boolean;
};

/**
 * Describes the message guardianai.v1.payment.ScanCreditPackage.
 * Use `create(ScanCreditPackageSchema)` to create a new message.
 */
export const ScanCreditPackageSchema: GenMessage<ScanCreditPackage, {jsonType: ScanCreditPackageJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 42);

/**
 * @generated from message guardianai.v1.payment.CheckCreditsRequest
 */
export type CheckCreditsRequest = Message<"guardianai.v1.payment.CheckCreditsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int64 required_credits = 2;
   */
  requiredCredits: bigint;
};

/**
 * @generated from message guardianai.v1.payment.CheckCreditsRequest
 */
export type CheckCreditsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int64 required_credits = 2;
   */
  requiredCredits?: string;
};

/**
 * Describes the message guardianai.v1.payment.CheckCreditsRequest.
 * Use `create(CheckCreditsRequestSchema)` to create a new message.
 */
export const CheckCreditsRequestSchema: GenMessage<CheckCreditsRequest, {jsonType: CheckCreditsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 43);

/**
 * @generated from message guardianai.v1.payment.CheckCreditsResponse
 */
export type CheckCreditsResponse = Message<"guardianai.v1.payment.CheckCreditsResponse"> & {
  /**
   * @generated from field: bool sufficient = 1;
   */
  sufficient: boolean;

  /**
   * @generated from field: int64 available = 2;
   */
  available: bigint;

  /**
   * @generated from field: int64 required = 3;
   */
  required: bigint;

  /**
   * @generated from field: int64 shortfall = 4;
   */
  shortfall: bigint;
};

/**
 * @generated from message guardianai.v1.payment.CheckCreditsResponse
 */
export type CheckCreditsResponseJson = {
  /**
   * @generated from field: bool sufficient = 1;
   */
  sufficient?: boolean;

  /**
   * @generated from field: int64 available = 2;
   */
  available?: string;

  /**
   * @generated from field: int64 required = 3;
   */
  required?: string;

  /**
   * @generated from field: int64 shortfall = 4;
   */
  shortfall?: string;
};

/**
 * Describes the message guardianai.v1.payment.CheckCreditsResponse.
 * Use `create(CheckCreditsResponseSchema)` to create a new message.
 */
export const CheckCreditsResponseSchema: GenMessage<CheckCreditsResponse, {jsonType: CheckCreditsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 44);

/**
 * @generated from message guardianai.v1.payment.CreatePoolRequest
 */
export type CreatePoolRequest = Message<"guardianai.v1.payment.CreatePoolRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 initial_credits = 3;
   */
  initialCredits: bigint;
};

/**
 * @generated from message guardianai.v1.payment.CreatePoolRequest
 */
export type CreatePoolRequestJson = {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: int64 initial_credits = 3;
   */
  initialCredits?: string;
};

/**
 * Describes the message guardianai.v1.payment.CreatePoolRequest.
 * Use `create(CreatePoolRequestSchema)` to create a new message.
 */
export const CreatePoolRequestSchema: GenMessage<CreatePoolRequest, {jsonType: CreatePoolRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 45);

/**
 * @generated from message guardianai.v1.payment.PoolResponse
 */
export type PoolResponse = Message<"guardianai.v1.payment.PoolResponse"> & {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string owner_id = 3;
   */
  ownerId: string;

  /**
   * @generated from field: int64 total_credits = 4;
   */
  totalCredits: bigint;

  /**
   * @generated from field: int64 available_credits = 5;
   */
  availableCredits: bigint;

  /**
   * @generated from field: int32 member_count = 6;
   */
  memberCount: number;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.PoolResponse
 */
export type PoolResponseJson = {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string owner_id = 3;
   */
  ownerId?: string;

  /**
   * @generated from field: int64 total_credits = 4;
   */
  totalCredits?: string;

  /**
   * @generated from field: int64 available_credits = 5;
   */
  availableCredits?: string;

  /**
   * @generated from field: int32 member_count = 6;
   */
  memberCount?: number;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.PoolResponse.
 * Use `create(PoolResponseSchema)` to create a new message.
 */
export const PoolResponseSchema: GenMessage<PoolResponse, {jsonType: PoolResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 46);

/**
 * @generated from message guardianai.v1.payment.JoinPoolRequest
 */
export type JoinPoolRequest = Message<"guardianai.v1.payment.JoinPoolRequest"> & {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.JoinPoolRequest
 */
export type JoinPoolRequestJson = {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.JoinPoolRequest.
 * Use `create(JoinPoolRequestSchema)` to create a new message.
 */
export const JoinPoolRequestSchema: GenMessage<JoinPoolRequest, {jsonType: JoinPoolRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 47);

/**
 * @generated from message guardianai.v1.payment.JoinPoolResponse
 */
export type JoinPoolResponse = Message<"guardianai.v1.payment.JoinPoolResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.JoinPoolResponse
 */
export type JoinPoolResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.JoinPoolResponse.
 * Use `create(JoinPoolResponseSchema)` to create a new message.
 */
export const JoinPoolResponseSchema: GenMessage<JoinPoolResponse, {jsonType: JoinPoolResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 48);

/**
 * @generated from message guardianai.v1.payment.LeavePoolRequest
 */
export type LeavePoolRequest = Message<"guardianai.v1.payment.LeavePoolRequest"> & {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.LeavePoolRequest
 */
export type LeavePoolRequestJson = {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.LeavePoolRequest.
 * Use `create(LeavePoolRequestSchema)` to create a new message.
 */
export const LeavePoolRequestSchema: GenMessage<LeavePoolRequest, {jsonType: LeavePoolRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 49);

/**
 * @generated from message guardianai.v1.payment.LeavePoolResponse
 */
export type LeavePoolResponse = Message<"guardianai.v1.payment.LeavePoolResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.LeavePoolResponse
 */
export type LeavePoolResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.LeavePoolResponse.
 * Use `create(LeavePoolResponseSchema)` to create a new message.
 */
export const LeavePoolResponseSchema: GenMessage<LeavePoolResponse, {jsonType: LeavePoolResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 50);

/**
 * @generated from message guardianai.v1.payment.GetPoolRequest
 */
export type GetPoolRequest = Message<"guardianai.v1.payment.GetPoolRequest"> & {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetPoolRequest
 */
export type GetPoolRequestJson = {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetPoolRequest.
 * Use `create(GetPoolRequestSchema)` to create a new message.
 */
export const GetPoolRequestSchema: GenMessage<GetPoolRequest, {jsonType: GetPoolRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 51);

/**
 * @generated from message guardianai.v1.payment.AllocateCreditsRequest
 */
export type AllocateCreditsRequest = Message<"guardianai.v1.payment.AllocateCreditsRequest"> & {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: int64 credits = 3;
   */
  credits: bigint;
};

/**
 * @generated from message guardianai.v1.payment.AllocateCreditsRequest
 */
export type AllocateCreditsRequestJson = {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: int64 credits = 3;
   */
  credits?: string;
};

/**
 * Describes the message guardianai.v1.payment.AllocateCreditsRequest.
 * Use `create(AllocateCreditsRequestSchema)` to create a new message.
 */
export const AllocateCreditsRequestSchema: GenMessage<AllocateCreditsRequest, {jsonType: AllocateCreditsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 52);

/**
 * @generated from message guardianai.v1.payment.AllocateCreditsResponse
 */
export type AllocateCreditsResponse = Message<"guardianai.v1.payment.AllocateCreditsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int64 allocated = 2;
   */
  allocated: bigint;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.AllocateCreditsResponse
 */
export type AllocateCreditsResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: int64 allocated = 2;
   */
  allocated?: string;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.AllocateCreditsResponse.
 * Use `create(AllocateCreditsResponseSchema)` to create a new message.
 */
export const AllocateCreditsResponseSchema: GenMessage<AllocateCreditsResponse, {jsonType: AllocateCreditsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 53);

/**
 * @generated from message guardianai.v1.payment.GetPoolMembersRequest
 */
export type GetPoolMembersRequest = Message<"guardianai.v1.payment.GetPoolMembersRequest"> & {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetPoolMembersRequest
 */
export type GetPoolMembersRequestJson = {
  /**
   * @generated from field: string pool_id = 1;
   */
  poolId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetPoolMembersRequest.
 * Use `create(GetPoolMembersRequestSchema)` to create a new message.
 */
export const GetPoolMembersRequestSchema: GenMessage<GetPoolMembersRequest, {jsonType: GetPoolMembersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 54);

/**
 * @generated from message guardianai.v1.payment.PoolMembersResponse
 */
export type PoolMembersResponse = Message<"guardianai.v1.payment.PoolMembersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.PoolMember members = 1;
   */
  members: PoolMember[];
};

/**
 * @generated from message guardianai.v1.payment.PoolMembersResponse
 */
export type PoolMembersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.PoolMember members = 1;
   */
  members?: PoolMemberJson[];
};

/**
 * Describes the message guardianai.v1.payment.PoolMembersResponse.
 * Use `create(PoolMembersResponseSchema)` to create a new message.
 */
export const PoolMembersResponseSchema: GenMessage<PoolMembersResponse, {jsonType: PoolMembersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 55);

/**
 * @generated from message guardianai.v1.payment.PoolMember
 */
export type PoolMember = Message<"guardianai.v1.payment.PoolMember"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: int64 allocated_credits = 3;
   */
  allocatedCredits: bigint;

  /**
   * @generated from field: int64 used_credits = 4;
   */
  usedCredits: bigint;

  /**
   * @generated from field: int64 joined_at = 5;
   */
  joinedAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.PoolMember
 */
export type PoolMemberJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: int64 allocated_credits = 3;
   */
  allocatedCredits?: string;

  /**
   * @generated from field: int64 used_credits = 4;
   */
  usedCredits?: string;

  /**
   * @generated from field: int64 joined_at = 5;
   */
  joinedAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.PoolMember.
 * Use `create(PoolMemberSchema)` to create a new message.
 */
export const PoolMemberSchema: GenMessage<PoolMember, {jsonType: PoolMemberJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 56);

/**
 * @generated from message guardianai.v1.payment.TransferCreditsRequest
 */
export type TransferCreditsRequest = Message<"guardianai.v1.payment.TransferCreditsRequest"> & {
  /**
   * @generated from field: string from_user_id = 1;
   */
  fromUserId: string;

  /**
   * @generated from field: string to_user_id = 2;
   */
  toUserId: string;

  /**
   * @generated from field: int64 credits = 3;
   */
  credits: bigint;

  /**
   * @generated from field: string note = 4;
   */
  note: string;
};

/**
 * @generated from message guardianai.v1.payment.TransferCreditsRequest
 */
export type TransferCreditsRequestJson = {
  /**
   * @generated from field: string from_user_id = 1;
   */
  fromUserId?: string;

  /**
   * @generated from field: string to_user_id = 2;
   */
  toUserId?: string;

  /**
   * @generated from field: int64 credits = 3;
   */
  credits?: string;

  /**
   * @generated from field: string note = 4;
   */
  note?: string;
};

/**
 * Describes the message guardianai.v1.payment.TransferCreditsRequest.
 * Use `create(TransferCreditsRequestSchema)` to create a new message.
 */
export const TransferCreditsRequestSchema: GenMessage<TransferCreditsRequest, {jsonType: TransferCreditsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 57);

/**
 * @generated from message guardianai.v1.payment.TransferResponse
 */
export type TransferResponse = Message<"guardianai.v1.payment.TransferResponse"> & {
  /**
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.TransferResponse
 */
export type TransferResponseJson = {
  /**
   * @generated from field: string transfer_id = 1;
   */
  transferId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.TransferResponse.
 * Use `create(TransferResponseSchema)` to create a new message.
 */
export const TransferResponseSchema: GenMessage<TransferResponse, {jsonType: TransferResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 58);

/**
 * @generated from message guardianai.v1.payment.GetTransferHistoryRequest
 */
export type GetTransferHistoryRequest = Message<"guardianai.v1.payment.GetTransferHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.payment.GetTransferHistoryRequest
 */
export type GetTransferHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.payment.GetTransferHistoryRequest.
 * Use `create(GetTransferHistoryRequestSchema)` to create a new message.
 */
export const GetTransferHistoryRequestSchema: GenMessage<GetTransferHistoryRequest, {jsonType: GetTransferHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 59);

/**
 * @generated from message guardianai.v1.payment.TransferHistoryResponse
 */
export type TransferHistoryResponse = Message<"guardianai.v1.payment.TransferHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.CreditTransfer transfers = 1;
   */
  transfers: CreditTransfer[];
};

/**
 * @generated from message guardianai.v1.payment.TransferHistoryResponse
 */
export type TransferHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.CreditTransfer transfers = 1;
   */
  transfers?: CreditTransferJson[];
};

/**
 * Describes the message guardianai.v1.payment.TransferHistoryResponse.
 * Use `create(TransferHistoryResponseSchema)` to create a new message.
 */
export const TransferHistoryResponseSchema: GenMessage<TransferHistoryResponse, {jsonType: TransferHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 60);

/**
 * @generated from message guardianai.v1.payment.CreditTransfer
 */
export type CreditTransfer = Message<"guardianai.v1.payment.CreditTransfer"> & {
  /**
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;

  /**
   * @generated from field: string from_user_id = 2;
   */
  fromUserId: string;

  /**
   * @generated from field: string to_user_id = 3;
   */
  toUserId: string;

  /**
   * @generated from field: int64 credits = 4;
   */
  credits: bigint;

  /**
   * @generated from field: string note = 5;
   */
  note: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.CreditTransfer
 */
export type CreditTransferJson = {
  /**
   * @generated from field: string transfer_id = 1;
   */
  transferId?: string;

  /**
   * @generated from field: string from_user_id = 2;
   */
  fromUserId?: string;

  /**
   * @generated from field: string to_user_id = 3;
   */
  toUserId?: string;

  /**
   * @generated from field: int64 credits = 4;
   */
  credits?: string;

  /**
   * @generated from field: string note = 5;
   */
  note?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.CreditTransfer.
 * Use `create(CreditTransferSchema)` to create a new message.
 */
export const CreditTransferSchema: GenMessage<CreditTransfer, {jsonType: CreditTransferJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 61);

/**
 * @generated from message guardianai.v1.payment.ApplyPromoRequest
 */
export type ApplyPromoRequest = Message<"guardianai.v1.payment.ApplyPromoRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string promo_code = 2;
   */
  promoCode: string;
};

/**
 * @generated from message guardianai.v1.payment.ApplyPromoRequest
 */
export type ApplyPromoRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string promo_code = 2;
   */
  promoCode?: string;
};

/**
 * Describes the message guardianai.v1.payment.ApplyPromoRequest.
 * Use `create(ApplyPromoRequestSchema)` to create a new message.
 */
export const ApplyPromoRequestSchema: GenMessage<ApplyPromoRequest, {jsonType: ApplyPromoRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 62);

/**
 * @generated from message guardianai.v1.payment.ApplyPromoResponse
 */
export type ApplyPromoResponse = Message<"guardianai.v1.payment.ApplyPromoResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int64 credits_awarded = 2;
   */
  creditsAwarded: bigint;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.payment.ApplyPromoResponse
 */
export type ApplyPromoResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: int64 credits_awarded = 2;
   */
  creditsAwarded?: string;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.payment.ApplyPromoResponse.
 * Use `create(ApplyPromoResponseSchema)` to create a new message.
 */
export const ApplyPromoResponseSchema: GenMessage<ApplyPromoResponse, {jsonType: ApplyPromoResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 63);

/**
 * @generated from message guardianai.v1.payment.GetExpiringRequest
 */
export type GetExpiringRequest = Message<"guardianai.v1.payment.GetExpiringRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Optional: how many days ahead to check (default: 30)
   *
   * @generated from field: int32 days_ahead = 2;
   */
  daysAhead: number;
};

/**
 * @generated from message guardianai.v1.payment.GetExpiringRequest
 */
export type GetExpiringRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * Optional: how many days ahead to check (default: 30)
   *
   * @generated from field: int32 days_ahead = 2;
   */
  daysAhead?: number;
};

/**
 * Describes the message guardianai.v1.payment.GetExpiringRequest.
 * Use `create(GetExpiringRequestSchema)` to create a new message.
 */
export const GetExpiringRequestSchema: GenMessage<GetExpiringRequest, {jsonType: GetExpiringRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 64);

/**
 * @generated from message guardianai.v1.payment.ExpiringCreditsResponse
 */
export type ExpiringCreditsResponse = Message<"guardianai.v1.payment.ExpiringCreditsResponse"> & {
  /**
   * @generated from field: int64 expiring_credits = 1;
   */
  expiringCredits: bigint;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;

  /**
   * @generated from field: repeated guardianai.v1.payment.ExpiringBatch batches = 3;
   */
  batches: ExpiringBatch[];
};

/**
 * @generated from message guardianai.v1.payment.ExpiringCreditsResponse
 */
export type ExpiringCreditsResponseJson = {
  /**
   * @generated from field: int64 expiring_credits = 1;
   */
  expiringCredits?: string;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt?: string;

  /**
   * @generated from field: repeated guardianai.v1.payment.ExpiringBatch batches = 3;
   */
  batches?: ExpiringBatchJson[];
};

/**
 * Describes the message guardianai.v1.payment.ExpiringCreditsResponse.
 * Use `create(ExpiringCreditsResponseSchema)` to create a new message.
 */
export const ExpiringCreditsResponseSchema: GenMessage<ExpiringCreditsResponse, {jsonType: ExpiringCreditsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 65);

/**
 * @generated from message guardianai.v1.payment.ExpiringBatch
 */
export type ExpiringBatch = Message<"guardianai.v1.payment.ExpiringBatch"> & {
  /**
   * @generated from field: int64 credits = 1;
   */
  credits: bigint;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;

  /**
   * Where these credits came from (purchase, promo, etc.)
   *
   * @generated from field: string source = 3;
   */
  source: string;
};

/**
 * @generated from message guardianai.v1.payment.ExpiringBatch
 */
export type ExpiringBatchJson = {
  /**
   * @generated from field: int64 credits = 1;
   */
  credits?: string;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt?: string;

  /**
   * Where these credits came from (purchase, promo, etc.)
   *
   * @generated from field: string source = 3;
   */
  source?: string;
};

/**
 * Describes the message guardianai.v1.payment.ExpiringBatch.
 * Use `create(ExpiringBatchSchema)` to create a new message.
 */
export const ExpiringBatchSchema: GenMessage<ExpiringBatch, {jsonType: ExpiringBatchJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_payment, 66);

/**
 * @generated from service guardianai.v1.payment.PaymentService
 */
export const PaymentService: GenService<{
  /**
   * Create payment intent
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.CreatePaymentIntent
   */
  createPaymentIntent: {
    methodKind: "unary";
    input: typeof CreatePaymentIntentRequestSchema;
    output: typeof PaymentIntentResponseSchema;
  },
  /**
   * Confirm payment
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.ConfirmPayment
   */
  confirmPayment: {
    methodKind: "unary";
    input: typeof ConfirmPaymentRequestSchema;
    output: typeof PaymentResponseSchema;
  },
  /**
   * Get payment history
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.GetPaymentHistory
   */
  getPaymentHistory: {
    methodKind: "unary";
    input: typeof GetPaymentHistoryRequestSchema;
    output: typeof PaymentHistoryResponseSchema;
  },
  /**
   * Process refund
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.ProcessRefund
   */
  processRefund: {
    methodKind: "unary";
    input: typeof RefundRequestSchema;
    output: typeof RefundResponseSchema;
  },
  /**
   * Update payment method
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.UpdatePaymentMethod
   */
  updatePaymentMethod: {
    methodKind: "unary";
    input: typeof UpdatePaymentMethodRequestSchema;
    output: typeof PaymentMethodResponseSchema;
  },
  /**
   * Get invoices
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.GetInvoices
   */
  getInvoices: {
    methodKind: "unary";
    input: typeof GetInvoicesRequestSchema;
    output: typeof InvoicesResponseSchema;
  },
  /**
   * Handle Stripe webhook
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.HandleWebhook
   */
  handleWebhook: {
    methodKind: "unary";
    input: typeof WebhookRequestSchema;
    output: typeof WebhookResponseSchema;
  },
  /**
   * Initiate payment (simpler flow for frontend)
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.InitiatePayment
   */
  initiatePayment: {
    methodKind: "unary";
    input: typeof InitiatePaymentRequestSchema;
    output: typeof PaymentResponseSchema;
  },
  /**
   * Get payment status
   *
   * @generated from rpc guardianai.v1.payment.PaymentService.GetPaymentStatus
   */
  getPaymentStatus: {
    methodKind: "unary";
    input: typeof GetPaymentStatusRequestSchema;
    output: typeof PaymentStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_payment_payment, 0);

/**
 * @generated from service guardianai.v1.payment.SubscriptionService
 */
export const SubscriptionService: GenService<{
  /**
   * @generated from rpc guardianai.v1.payment.SubscriptionService.CreateSubscription
   */
  createSubscription: {
    methodKind: "unary";
    input: typeof CreateSubscriptionRequestSchema;
    output: typeof SubscriptionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.SubscriptionService.GetSubscriptionStatus
   */
  getSubscriptionStatus: {
    methodKind: "unary";
    input: typeof GetSubscriptionStatusRequestSchema;
    output: typeof SubscriptionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.SubscriptionService.CancelSubscription
   */
  cancelSubscription: {
    methodKind: "unary";
    input: typeof CancelSubscriptionRequestSchema;
    output: typeof CancelSubscriptionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.SubscriptionService.SubscribeToPlan
   */
  subscribeToPlan: {
    methodKind: "unary";
    input: typeof SubscribeToPlanRequestSchema;
    output: typeof SubscribeResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.SubscriptionService.ListActiveProductSubscriptions
   */
  listActiveProductSubscriptions: {
    methodKind: "unary";
    input: typeof ListActiveProductSubscriptionsRequestSchema;
    output: typeof ListActiveProductSubscriptionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_payment_payment, 1);

/**
 * @generated from service guardianai.v1.payment.ScanCreditService
 */
export const ScanCreditService: GenService<{
  /**
   * Core credit operations
   *
   * @generated from rpc guardianai.v1.payment.ScanCreditService.CreateScanCreditCheckoutSession
   */
  createScanCreditCheckoutSession: {
    methodKind: "unary";
    input: typeof CreateScanCreditCheckoutSessionRequestSchema;
    output: typeof ScanCreditCheckoutSessionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetScanCreditBalance
   */
  getScanCreditBalance: {
    methodKind: "unary";
    input: typeof GetScanCreditBalanceRequestSchema;
    output: typeof ScanCreditBalanceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.ListScanCreditUsage
   */
  listScanCreditUsage: {
    methodKind: "unary";
    input: typeof ListScanCreditUsageRequestSchema;
    output: typeof ScanCreditUsageListResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.DeductCredits
   */
  deductCredits: {
    methodKind: "unary";
    input: typeof DeductCreditsRequestSchema;
    output: typeof ScanCreditBalanceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.AddCredits
   */
  addCredits: {
    methodKind: "unary";
    input: typeof AddCreditsRequestSchema;
    output: typeof ScanCreditBalanceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetCreditHistory
   */
  getCreditHistory: {
    methodKind: "unary";
    input: typeof GetCreditHistoryRequestSchema;
    output: typeof CreditHistoryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetScanCreditPackages
   */
  getScanCreditPackages: {
    methodKind: "unary";
    input: typeof GetScanCreditPackagesRequestSchema;
    output: typeof ScanCreditPackagesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.CheckSufficientCredits
   */
  checkSufficientCredits: {
    methodKind: "unary";
    input: typeof CheckCreditsRequestSchema;
    output: typeof CheckCreditsResponseSchema;
  },
  /**
   * Credit pool management (Enterprise B2B feature)
   *
   * @generated from rpc guardianai.v1.payment.ScanCreditService.CreateCreditPool
   */
  createCreditPool: {
    methodKind: "unary";
    input: typeof CreatePoolRequestSchema;
    output: typeof PoolResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.JoinCreditPool
   */
  joinCreditPool: {
    methodKind: "unary";
    input: typeof JoinPoolRequestSchema;
    output: typeof JoinPoolResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.LeaveCreditPool
   */
  leaveCreditPool: {
    methodKind: "unary";
    input: typeof LeavePoolRequestSchema;
    output: typeof LeavePoolResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetPoolDetails
   */
  getPoolDetails: {
    methodKind: "unary";
    input: typeof GetPoolRequestSchema;
    output: typeof PoolResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.AllocatePoolCredits
   */
  allocatePoolCredits: {
    methodKind: "unary";
    input: typeof AllocateCreditsRequestSchema;
    output: typeof AllocateCreditsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetPoolMembers
   */
  getPoolMembers: {
    methodKind: "unary";
    input: typeof GetPoolMembersRequestSchema;
    output: typeof PoolMembersResponseSchema;
  },
  /**
   * Credit transfers (P2P feature)
   *
   * @generated from rpc guardianai.v1.payment.ScanCreditService.TransferCredits
   */
  transferCredits: {
    methodKind: "unary";
    input: typeof TransferCreditsRequestSchema;
    output: typeof TransferResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetTransferHistory
   */
  getTransferHistory: {
    methodKind: "unary";
    input: typeof GetTransferHistoryRequestSchema;
    output: typeof TransferHistoryResponseSchema;
  },
  /**
   * Promotional features
   *
   * @generated from rpc guardianai.v1.payment.ScanCreditService.ApplyPromoCode
   */
  applyPromoCode: {
    methodKind: "unary";
    input: typeof ApplyPromoRequestSchema;
    output: typeof ApplyPromoResponseSchema;
  },
  /**
   * Credit expiry visibility
   *
   * @generated from rpc guardianai.v1.payment.ScanCreditService.GetExpiringCredits
   */
  getExpiringCredits: {
    methodKind: "unary";
    input: typeof GetExpiringRequestSchema;
    output: typeof ExpiringCreditsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_payment_payment, 2);

